import { useTranslation } from "react-i18next";
import SEO from "../app/SEO";
import LegalContent from "./LegalContent";

export const Slavery = () => {
    const { t } = useTranslation("legal");
    const sections: any[] = t("policies.slavery.sections", { returnObjects: true });

    return (
        <>
            <SEO title={{ title: t("policies.slavery.fullTitle"), pageTitle: t("policies.slavery.fullTitle") }} canonicalPath="/legal/slavery" />
            <LegalContent
                title={t("policies.slavery.title")}
                subtitle={t("policies.slavery.subtitle")}
                updated={t("lblUpdated", { date: t("policies.slavery.updated") })}
                sections={sections} />
        </>
    );
};